<template>
    <div class="field">
        <div class="control" v-bind:class="{ 'is-loading': isLoading }">
            <input class="input is-small" v-model="carData.query.jibaiseki" v-on:change="updateRecFee()" type="text" >
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    export default {
        props:['car'],
        data () {
            return {
                isLoading: false,
                isActive: false,
                carData:{
                    id: this.car.id,
                    query: {
                        jibaiseki: this.car.jibaiseki,
                    }
                }
            }
        },
        methods: {
            updateRecFee() {
                this.isLoading = true;
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },

        },
        computed: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .is-small {
        max-width: 80px;
    }
    .control {
        max-width: 80px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Jibaiseki/JibaisekiColumn.vue